// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b368eb4d","732":"4fe3e76d","977":"48f0a5b1"}[chunkId] + ".chunk.js";
};